import type {
  StyleBadgeFragment,
  StyleBadgeMetaobjectFragment,
} from '@shared/types/storefront/graphql'

export type StyleBadgeImageRef = {
  url: string
  altText: string | undefined
}

export type StyleBadgeData = {
  color: string | undefined
  image: StyleBadgeImageRef | undefined
  focus: StyleBadgeImageRef | undefined
}

const getImageRef = (
  field: StyleBadgeMetaobjectFragment['image']
): StyleBadgeImageRef | undefined => {
  const ref = field?.reference
  if (!ref || !('image' in ref) || !ref.image?.url) return undefined

  return {
    url: ref.image.url,
    altText: ref.image.altText ?? undefined,
  }
}

export const toStyleBadge = (
  styleBadge: StyleBadgeFragment | undefined | null
): StyleBadgeData | undefined => {
  const reference = styleBadge?.reference

  if (!reference || reference.__typename !== 'Metaobject') {
    return undefined
  }

  return {
    color: reference.color?.value ?? undefined,
    image: getImageRef(reference.image),
    focus: getImageRef(reference.focus),
  }
}
